export {
  GUIDANCE_EVENTS,
  GUIDANCE_EVENT_NAMES,
  GUIDANCE_EVENT_PREFIX,
  GUIDANCE_PROPERTY_MAX_LENGTH,
  type GuidanceEventName,
  type GuidanceEventProperties,
  type GuidanceEventPropertyValue
} from './events';
export { trackGuidanceEvent } from './track';
export {
  observeGettingStartedCompletions,
  resetGettingStartedCompletionsForTest
} from './getting-started-completions';
export {
  GUIDANCE_AREAS,
  HELP_CENTRE_ORIGIN,
  INTERCOM_TOURS,
  IN_PRODUCT_ARTICLES,
  ROUTES_WITHOUT_GUIDANCE,
  helpDestinationUrl,
  listGuidanceHelpDestinations,
  listGuidanceTours,
  listHelpRoutes,
  type GuidanceArea,
  type HelpDestination,
  type IntercomTourName
} from './areas';
export {
  GUIDANCE_SURFACES,
  UNINSTRUMENTED_GUIDANCE_SURFACES,
  type GuidanceSurface
} from './surfaces';
